// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>32</span>&nbsp;&nbsp;I will praise the name of God with a song;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I will proclaim his greatness with thanksgiving.<br> </p> </div></div>";
// Exports
module.exports = code;